import CoWorkChatVisual from './CoWorkChatVisual';

/** Full-size conversational mock for cowork_clip2 (termination pressure). */
export default function HrDomainChatVisual() {
  return <CoWorkChatVisual scenarioId="cowork_clip2" />;
}
